export default __webpack_public_path__ + "static/media/mitigation-bathroom-damage-view-1.e19fb7aa.jpg";